module.exports = __webpack_public_path__ + "static/media/150.104aa33e.jpg";